import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./Section.scss";

import Aos from "aos";

function Home() {
	Aos.init({
		delay: 500,
		once: true
	});
	return (
		<div className="sec2">
			<div className="container">
				<div className="sec2Head">
					<h6 className="small-title" data-aos="zoom-in">
						GGI Team
					</h6>
					<h2 className="title" data-aos="flip-down">

					GGILab: Pioneering Gemological Excellence
					</h2>
					<p data-aos="fade-up">
					GGILab is at the forefront of gemological innovation in Pakistan. As the first laboratory to offer online verification of gemstone certificates, we've revolutionized the way gemstones are authenticated. Additionally, we're pioneers in sealing diamonds and gemstones, ensuring their authenticity and integrity.

					</p>
				</div>
				<div className="row">
					<div className="center">
						<h2 className="title" data-aos="fade-down-left">
							GGI Expertise
						</h2>
					</div>
					<div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
						<div className="leftpoints col-md-4 col-sm-12">
							<div className="point" data-aos-delay="1500" data-aos="flip-left">
								<div>
									<h5>X-Ray flourescense</h5>
									<p>
									X-Ray Fluorescence (XRF) is a versatile technique used to identify and quantify the elemental composition of a sample. In the world of gemology, XRF is particularly valuable for determining the karatage of gold jewelry and identifying a wide range of elements, including precious metals like platinum and silver. It's also used to distinguish between natural and synthetic gemstones and to identify treatments that may alter a gemstone's appearance or value
									</p>
								</div>
								<div>
									<img alt="flourence"
										src={
											"https://res.cloudinary.com/ggi/image/upload/v1637903443/X-RAY_FLOURESCENSE_sacjur.webp"
										}
										className="machine"
										data-aos="zoom-in-down"
									/>
								</div>
							</div>
							<div className="point" data-aos-delay="1500" data-aos="flip-right">
								<div>
									<h5>Raman Spectroscopy</h5>
									<p>
									Raman Spectroscopy is a non-destructive technique that
									 analyzes the vibrational modes of molecules. In gemology, 
									 it's used to identify different types of gemstones, such
									  as diamonds, rubies, sapphires, and emeralds. It can also 
									  detect treatments like heat treatment, irradiation, and 
									  other processes that may alter a gemstone's properties.
									   Additionally, Raman spectroscopy can differentiate 
									   between natural and synthetic gemstones, particularly 
									   diamonds, emeralds, and other valuable stones.


									</p>
								</div>
								<div data-aos="flip-up">
									<img
									alt="Spectroscopy"
										src={
											"https://res.cloudinary.com/ggi/image/upload/v1637903436/Raman_Spectroscopy_xhpnaz.webp"
										}
										className="machine"
										data-aos="zoom-in-down"
									/>
								</div>
							</div>
						</div>
						<div className="diamondImage col-md-3 col-sm-12">
							<img
							alt="Diamond__Round"
								src={
									"https://res.cloudinary.com/ggi/image/upload/v1637903415/Diamond__Round-Rotating_txrmlp.webp"
								}
								data-aos="zoom-in"
							/>
						</div>
						<div className="rightPoint col-md-4 col-sm-12">
							<div className="point" data-aos-delay="1500" data-aos="flip-down">
								<div>
									<h5>FTIR</h5>
									<p>
									Fourier Transform Infrared Spectroscopy (FTIR) is a technique that measures the absorption of infrared light by a sample. In gemology, it's used to identify gemstone species, detect treatments, and analyze organic materials used in treatments or fillers.

									</p>
								</div>
								<div>
									<img
									alt="FTIR"
										src={"https://res.cloudinary.com/ggi/image/upload/v1637903422/FTIR_mdxn94.webp"}
										className="machine"
										data-aos="zoom-in-down"
									/>
								</div>
							</div>
							<div className="point" data-aos-delay="1500" data-aos="zoom-in">
								<div>
									<h5>Delta XRF (X-Ray Fluorescence)</h5>
									<p>
									Delta XRF is a specialized type of XRF that is particularly sensitive to small variations in elemental composition. It's used to analyze alloys, identify gemstone treatments, and analyze mineral samples.

									</p>

								</div>
								<div>
									<img
									alt="Delta"
										src={
											"https://res.cloudinary.com/ggi/image/upload/v1637903389/Delta_XRF_iwbzxe.webp"
										}
										className="machine"
										data-aos="zoom-in-down"
									/>
								</div>
						
						</div>
						
						</div>
						
					</div>
					<p data-aos="fade-up" style={{ color: '#6a707a' }}>
				    By combining these techniques,
				gemologists can accurately identify, 
				grade, and evaluate gemstones, ensuring fair 
				trade and protecting consumers from fraud.
			</p>
				</div>
		
				<div className="sec2Head">
					<h2 className="title" data-aos="fade-up-right">
						Evaluation Process
					</h2>
					<p data-aos="fade-up">
						Gemstone evaluation is a complex process which requires the stone to first be examined
						thoroughly, using the set standards. After examination, the following evaluation depends
						on the type of stone, its color, and quality. Upon completion of this stage, the stone
						is then minutely evaluated for every small detail, such as weight, color, clarity, and
						cut, among other things. Though these processes may seem small, they require complete
						attention and careful study of the gem, which is carried out responsibly by the team at
						GGI.
					</p>
					<p data-aos="fade-right">
						After meticulous and thorough examination of the gemstone, its certification report is
						generated by the company and updated on our website. Every report has a Certificate
						number, which can be used to view or print the report from the GGI website or verify the
						report through SMS.
					</p>
				</div>
			</div>
		</div>
	);
}
const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);
